module.exports = __webpack_public_path__ + "resources/img/img_tibero3_m.da36f46ce1b084752cec0e4c75a898d7.png";